import { render, staticRenderFns } from "./StandardRequestDialog.vue?vue&type=template&id=5a9f6db4"
import script from "./StandardRequestDialog.vue?vue&type=script&lang=js"
export * from "./StandardRequestDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports